import { checkIsInternal } from '@src/utility/createStorage';
import HttpService from '@src/utility/httpService';
import { config } from '@uhg-abyss/web/tools/config';
import { EDI_TOP_FILTER_API_BULK_URL, EDI_TOP_FILTER_API_CLAIM_SEARCH_URL, EDI_TOP_FILTER_API_EDI_URL, EDI_TOP_FILTER_API_STANDARD_SEARCH_URL} from './apiUrlConstants';

const _httpService = new HttpService();
const _httpServiceBulk = new HttpService();

const apiDomainInternal = config('API_DOMAIN_INTERNAL') ?? '';
const apiDomainExternal = config('API_DOMAIN_EXTERNAL') ?? '';

if (checkIsInternal()) {
  _httpService.setBaseURL(apiDomainInternal);
   _httpServiceBulk.setBaseURL(config('BULK_PROCESSING_API') || '');
} else {
  _httpService.setBaseURL(apiDomainExternal);
    _httpServiceBulk.setBaseURL(config('BULK_PROCESSING_API') || '');
}
// _httpServiceBulk.setBaseURL(config('BULK_PROCESSING_API') || '');

export const getEdiFilterDataRequest = async (payload: any, _type?: string) => {
  const url = _type === "market" ? EDI_TOP_FILTER_API_CLAIM_SEARCH_URL : EDI_TOP_FILTER_API_STANDARD_SEARCH_URL;
  const responseData: any = await _httpService.push(url, payload);
  return responseData.Data;
};

export const getEdiFilterDataBulkRequest = async (payload: any, _type?: string) => {
  const url = EDI_TOP_FILTER_API_EDI_URL;
  const responseData: any = await _httpServiceBulk.push(url, payload);
  return responseData.Data;
};

export const getEdiFilterDataBulkJobRequest = async (payload: any, _type?: string) => {
  const url = EDI_TOP_FILTER_API_BULK_URL;
  const responseData: any = await _httpServiceBulk.push(url, payload);
  return responseData.Data;
};

